import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkPopularSkusMinimalGrid.module.css';

export function DevlinkPopularSkusMinimalGrid({ as: _Component = _Builtin.Section, sectionTitle = 'Popular Services', skuItems }) {
  return (
    <_Component
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'align-center')} tag="div">
          <_Builtin.Heading className={_utils.cx(_styles, 'txt-header')} tag="h2">
            {sectionTitle}
          </_Builtin.Heading>
          <_Builtin.Block className={_utils.cx(_styles, 'medium')} tag="div" />
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, 'col-5')} tag="div">
          {skuItems}
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
